module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/not-authorized/not-authorized.component.css
// module id = ./src/app/pages/errors/not-authorized/not-authorized.component.css
// module chunks = main